export const ITEM_CATEGORIES = {
  accessories: { label: ["palworld:category.accessory", "Accessory"] },
  ammo: { label: ["palworld:category.ammo", "Ammo"] },
  armor: { label: ["palworld:category.armor", "Armor"] },
  blueprints: { label: ["palworld:category.blueprint", "Blueprint"] },
  consumables: { label: ["palworld:category.consumable", "Consumable"] },
  foods: { label: ["palworld:category.food", "Food"] },
  gliders: { label: ["palworld:category.glider", "Glider"] },
  keyItems: { label: ["palworld:category.keyItem", "Key Item"] },
  materials: { label: ["palworld:category.material", "Material"] },
  spheres: { label: ["palworld:category.sphere", "Sphere"] },
  weapons: { label: ["palworld:category.weapon", "Weapon"] },
} as const;

export const ITEM_SUB_CATEGORIES = {
  accessory: { label: ["palworld:subCategory.accessory", "Accessory"] },
  ammo: { label: ["palworld:subCategory.ammo", "Ammo"] },
  armorBody: { label: ["palworld:subCategory.armorBody", "Body Armor"] },
  armorHead: { label: ["palworld:subCategory.armorHead", "Head Armor"] },
  blueprint: { label: ["palworld:subCategory.blueprint", "Blueprint"] },
  bow: { label: ["palworld:subCategory.bow", "Bow"] },
  crossbow: { label: ["palworld:subCategory.crossbow", "Crossbow"] },
  drug: { label: ["palworld:subCategory.drug", "Drug"] },
  gems: { label: ["palworld:subCategory.gems", "Gems"] },
  glider: { label: ["palworld:category.glider", "Glider"] },
  handgun: { label: ["palworld:subCategory.handgun", "Handgun"] },
  ingot: { label: ["palworld:subCategory.ingot", "Ingot"] },
  keyItem: { label: ["palworld:subCategory.keyItem", "Key Item"] },
  launcher: { label: ["palworld:subCategory.launcher", "Launcher"] },
  meat: { label: ["palworld:subCategory.foodMeat", "Meat"] },
  medicine: { label: ["palworld:subCategory.medicine", "Medicine"] },
  melee: { label: ["palworld:subCategory.melee", "Melee"] },
  money: { label: ["palworld:subCategory.glider", "Money"] },
  ore: { label: ["palworld:subCategory.ore", "Ore"] },
  palDrops: { label: ["palworld:subCategory.monsterDrop", "Pal Drop"] },
  palEgg: { label: ["palworld:subCategory.palEgg", "Pal Egg"] },
  preparedFish: { label: ["palworld:subCategory.foodDishFish", "Fish Dish"] },
  preparedMeat: { label: ["palworld:subCategory.foodDishMeat", "Meat Dish"] },
  preparedVegetable: {
    label: ["palworld:subCategory.vegetableDish", "Vegetable Dish"],
  },
  processedMaterial: {
    label: ["palworld:subCategory.craftingMat", "Crafting Material"],
  },
  rifle: { label: ["palworld:subCategory.rifle", "Rifle"] },
  shield: { label: ["palworld:subCategory.shield", "Shield"] },
  shotgun: { label: ["palworld:subCategory.shotgun", "Shotgun"] },
  skillFruit: { label: ["palworld:subCategory.skillFruit", "Skill Fruit"] },
  sphere: { label: ["palworld:subCategory.sphere", "Sphere"] },
  stone: { label: ["palworld:subCategory.stone", "Stone"] },
  techAccessory: {
    label: ["palworld:subCategory.techAccessory", "Ancient Tech"],
  },
  techBook: { label: ["palworld:subCategory.techBook", "Technology Book"] },
  thrown: { label: ["palworld:subCategory.thrown", "Thrown"] },
  utility: { label: ["palworld:subCategory.utility", "Utility"] },
  vegetable: { label: ["palworld:subCategory.foodVegetable", "Vegetable"] },
  wood: { label: ["palworld:subCategory.wood", "Wood"] },

  // Test items only?
  // ----------------
  // FoodFish: ["palworld:subCategory.foodFish", "Dish"],
  // WeaponSniperRifle: ["palworld:subCategory.sniperRifle", "Sniper Rifle"],
  // WeaponGatlingGun: ["palworld:subCategory.gatlingGun", "Gatling Gun"],
  // WeaponFlameThrower: ["palworld:subCategory.flameThrower", "Flame Thrower"],
  // SPWeaponCaptureRope
  // MonsterEquipWeapon
  // FoodProcessed: ["palworld:subCategory.foodProcessed", "Processed"],
  // ConsumeSeed
  // ConsumeBandage
} as const;

export type ItemCategory = keyof typeof ITEM_CATEGORIES;
export type ItemSubCategory = keyof typeof ITEM_SUB_CATEGORIES;
